import Badge from '@codegouvfr/react-dsfr/Badge';
import { Button } from '@codegouvfr/react-dsfr/Button';
import React, { ReactNode } from 'react';
import { STEP_STATUS_STYLES } from '../../constants/step-status-styles';
import { StepStatus } from '../../types/enums/step-status.enum';
import './step-bloc.css';

export const StepBloc = ({ title, description, status, disabled, buttons }: StepBlocProps) => {
  const { text, severity } = STEP_STATUS_STYLES[status];

  return (
    <div className={'flex flex-col items-start gap-4 p-6 shadow-md relative bloc-left-dot'}
         style={{ backgroundColor: (disabled) ? '#EDEDED' : 'white' }}>

      <Badge severity={severity} noIcon>{text}</Badge>

      <h5 className={'mb-0!'} style={{ color: (disabled) ? '#B7B9CC' : 'black' }}>{title}</h5>

      <span style={{ color: (disabled) ? '#3A3A3A' : 'black' }}>{description}</span>

      <div className={'flex gap-4 my-2'}>
        {buttons.map(({ label, priority, onClick }, index) => (
          <Button key={`${index}-${label}`}
                  priority={priority}
                  onClick={() => onClick()}
                  disabled={disabled ?? false}>{label}</Button>
        ))}
      </div>
    </div>
  );
};

export interface StepBlocProps {
  status: StepStatus;
  title: ReactNode;
  description: string;
  buttons: StepButtonProps[];
  disabled?: boolean;
}

export interface StepButtonProps {
  label: string;
  priority: 'primary' | 'secondary';
  onClick: () => void;
}

